import { DataFilterOperator } from './filter-operator';
import { FilterFieldType } from './available-filter-fields';
import { DataFilterOperationType } from './filter-operation-type';

let filterConditionId = 0;

export class FilterCondition {
    readonly id: number;
    editMode?: boolean;

    constructor(
        public field: string,
        public operator: DataFilterOperator,
        public value: any,
        public fieldType: FilterFieldType = FilterFieldType.Text,
        public compareAttribute?: string | [string, string],
        public operationType: DataFilterOperationType = DataFilterOperationType.And,
    ) {
        this.id = ++filterConditionId;
    }
}
